import { AxiosResponse } from "axios";
import { apiQueryAdapter } from "../apiQueryAdapter";
import { DoorStatus, DoorType } from "./enums";
import { Door, LoadboardListManifestTrip, LoadboardListManifestRequestParams } from "./models";

export interface AssignDoorRequest {
  terminalNumber: number;
  doorNumber: string;
  driverId?: number | string | null;
  primaryDistributor: number;
  secondaryDistributors: number[];
  trailerNumber: number;
  manifest: number;
  carrierNumber: number;
  priority: number;
  doorStatus: DoorStatus | null;
  doorUsage: string;
  doorType: DoorType;
}


class LoadBoardService {
  private static instance: LoadBoardService;
  private constructor() { }

  static getInstance(): LoadBoardService {
    if (!LoadBoardService.instance) {
      LoadBoardService.instance = new LoadBoardService();
    }
    return LoadBoardService.instance;
  }

  public getDoors = async (terminalNumber: number): Promise<AxiosResponse<Door[]>> => {
    return await apiQueryAdapter.query(`/load-board/terminals/${terminalNumber}/doors`, "GET");
  };

  public assignDoor = async (request: AssignDoorRequest): Promise<AxiosResponse<void>> => {
    return await apiQueryAdapter.query(`/load-board/doors/assign`, "PUT", { body: request });
  };

  public getManifestTrips = async (
    params: LoadboardListManifestRequestParams
  ): Promise<AxiosResponse<LoadboardListManifestTrip[]>> => {

    const searchParams = new URLSearchParams();

    Object.entries(params).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== "") {
        searchParams.append(key, value.toString());
      }
    });

    const queryString = searchParams.toString();
    const url = queryString
      ? `/load-board/manifests/trips?${queryString}`
      : `/load-board/manifests/trips`;

    return await apiQueryAdapter.query(url, "GET");
  };

  public dispatchLoad = async (request: any): Promise<AxiosResponse<void>> => {
    return await apiQueryAdapter.query(`/load-board/doors/dispatchload`, "PUT", { body: request });
  };

  public closeDoor = async (request: any): Promise<AxiosResponse<void>> => {
    return await apiQueryAdapter.query(`/load-board/doors/closedoor`, "PUT", { body: request });
  };

}

export default LoadBoardService;